import { Navigate, Outlet, useLocation } from 'react-router-dom'

import { useAuth } from '@/hooks/use-auth'
import { routes } from '@/routes/config'

export function PublicRoute() {
  const location = useLocation()
  const { isAuthenticated } = useAuth()

  return isAuthenticated && location.pathname === routes.Login() ? (
    <Navigate to={routes.Diagnoses()} replace />
  ) : (
    <Outlet />
  )
}
